import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "map-page" }
const _hoisted_2 = { class: "map-overlay" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EleosMap = _resolveComponent("EleosMap")!
  const _component_LocationTrailerResultsList = _resolveComponent("LocationTrailerResultsList")!
  const _component_SelectedLocationToAttach = _resolveComponent("SelectedLocationToAttach")!
  const _component_DriverFeedback = _resolveComponent("DriverFeedback")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_EleosMap, {
        shouldFitMapView: true,
        points: _ctx.points,
        latitude: _ctx.mapLatitude,
        longitude: _ctx.mapLongitude,
        searchRadius: _ctx.mapRadius,
        selectedResult: _ctx.selectedResult,
        onSetSelectedResult: _ctx.setSelectedResult,
        onOnMapClick: _ctx.minimizeOverlay
      }, null, 8, ["points", "latitude", "longitude", "searchRadius", "selectedResult", "onSetSelectedResult", "onOnMapClick"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      (_ctx.noTrailerSelected)
        ? (_openBlock(), _createBlock(_component_LocationTrailerResultsList, {
            key: 0,
            isLoading: _ctx.loading,
            isRefreshing: _ctx.isRefreshing,
            isOverlayMinimized: _ctx.isOverlayMinimized,
            results: _ctx.allMapResults,
            selectedResult: _ctx.selectedResult,
            searchFilter: _ctx.searchFilter,
            onResetOverlayHeight: _ctx.resetOverlayHeight,
            onSetSearchFilter: _ctx.setSearchFilter,
            onSetSelectedResult: _ctx.setSelectedResult
          }, null, 8, ["isLoading", "isRefreshing", "isOverlayMinimized", "results", "selectedResult", "searchFilter", "onResetOverlayHeight", "onSetSearchFilter", "onSetSelectedResult"]))
        : (_openBlock(), _createBlock(_component_SelectedLocationToAttach, {
            key: 1,
            isOverlayMinimized: _ctx.isOverlayMinimized,
            results: _ctx.allMapResults,
            selectedResult: _ctx.selectedResult,
            onBackToListView: _ctx.backToListView,
            onResetOverlayHeight: _ctx.resetOverlayHeight,
            onSetSelectedResult: _ctx.setSelectedResult
          }, null, 8, ["isOverlayMinimized", "results", "selectedResult", "onBackToListView", "onResetOverlayHeight", "onSetSelectedResult"])),
      (!_ctx.loading)
        ? (_openBlock(), _createBlock(_component_DriverFeedback, {
            key: 2,
            trailers: _ctx.allMapResults,
            viewName: _ctx.viewName
          }, null, 8, ["trailers", "viewName"]))
        : _createCommentVNode("", true)
    ])
  ]))
}